export default "__VITE_ASSET__qSUOuv9Y__"